import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-2" }

import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
    import { computed } from 'vue';

    interface Props {
        currentPage: number;
        totalPages: number;
        maxVisiblePages?: number;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BasePagination',
  props: {
    currentPage: {},
    totalPages: {},
    maxVisiblePages: { default: 5 }
  },
  emits: ["pageChange"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const visiblePages = computed(() => {
        const pages: (number | string)[] = [];
        const halfVisible = Math.floor(props.maxVisiblePages / 2);
        let startPage = Math.max(1, props.currentPage - halfVisible);
        let endPage = Math.min(props.totalPages, startPage + props.maxVisiblePages - 1);

        if (endPage - startPage + 1 < props.maxVisiblePages) {
            startPage = Math.max(1, endPage - props.maxVisiblePages + 1);
        }

        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) {
                pages.push('...');
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < props.totalPages) {
            if (endPage < props.totalPages - 1) {
                pages.push('...');
            }
            pages.push(props.totalPages);
        }

        return pages;
    });

    const handlePageClick = (page: number | string) => {
        if (typeof page === 'number' && page !== props.currentPage) {
            emit('pageChange', page);
        }
    };

    const handlePrevious = () => {
        if (props.currentPage > 1) {
            emit('pageChange', props.currentPage - 1);
        }
    };

    const handleNext = () => {
        if (props.currentPage < props.totalPages) {
            emit('pageChange', props.currentPage + 1);
        }
    };

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_button, {
      onClick: handlePrevious,
      disabled: __props.currentPage === 1,
      fill: "outline",
      class: "h-10 w-10 p-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ChevronLeft), { class: "size-5" })
      ]),
      _: 1
    }, 8, ["disabled"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page, index) => {
      return (_openBlock(), _createBlock(_component_base_button, {
        key: index,
        onClick: ($event: any) => (handlePageClick(page)),
        disabled: page === '...',
        fill: page === __props.currentPage ? 'solid' : 'outline',
        class: _normalizeClass([
                'h-10 min-w-10 px-3',
                page === '...' &&
                    'cursor-default border-transparent bg-transparent hover:bg-transparent',
            ])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(page), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled", "fill", "class"]))
    }), 128)),
    _createVNode(_component_base_button, {
      onClick: handleNext,
      disabled: __props.currentPage === __props.totalPages,
      fill: "outline",
      class: "h-10 w-10 p-0"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ChevronRight), { class: "size-5" })
      ]),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})